/**
 * ResponsivePageContainer — UX1A Platform Primitive
 *
 * Standardises page padding, max-width, and mobile overflow behaviour.
 * Use this as the direct child of PageHeader on every page.
 *
 * Variants:
 *   default  — standard page (max-w-screen-xl, side padding, top padding)
 *   wide     — full-width tables / dashboards (no max-width constraint)
 *   form     — form-heavy pages (narrower, max-w-3xl)
 *
 * Usage:
 *   <ResponsivePageContainer>…</ResponsivePageContainer>
 *   <ResponsivePageContainer variant="wide">…</ResponsivePageContainer>
 *   <ResponsivePageContainer variant="form">…</ResponsivePageContainer>
 */
import React from "react";

const VARIANTS = {
  default: "max-w-screen-xl mx-auto px-4 py-6 md:px-8 md:py-8",
  wide:    "w-full px-4 py-6 md:px-8 md:py-8",
  form:    "max-w-3xl mx-auto px-4 py-6 md:px-8 md:py-8",
};

export function ResponsivePageContainer({
  children,
  variant = "default",
  className = "",
  "data-testid": testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`${VARIANTS[variant] || VARIANTS.default} ${className}`}
    >
      {children}
    </div>
  );
}
